import { render, staticRenderFns } from "./ManualDealsForm.vue?vue&type=template&id=f1705e1c&"
import script from "./ManualDealsForm.vue?vue&type=script&lang=js&"
export * from "./ManualDealsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports